/* Dalia Bella · opiniones de la ficha (sections/db-opiniones-ficha.liquid y snippets/db-opinion-tarjeta.liquid).
   Una instancia por sección [data-db-of]; se inicia al cargar y con shopify:section:load (editor de temas).
   - Filtros: botones [data-db-of-filtro] («todas», «fotos» o 1-5) en chips e histograma, con aria-pressed sincronizado.
     Volver a pulsar el filtro activo lo quita (vuelve a «todas»).
   - Orden: <select data-db-of-orden> (destacadas = orden de la lista, recientes, mejor, peor); reordena los nodos.
   - Desde 750 px, cuadrícula con data-por-pagina tarjetas y «Mostrar más opiniones»; en móvil, carrusel con todas.
     En la pista solo quedan las tarjetas visibles, así el contador «1 / N» de assets/dalia-ui.js cuenta bien: tras
     cada cambio el carrusel vuelve al principio y se le avisa con un evento scroll.
   - «Leer más» solo en las tarjetas cuyo texto desborda las 5 líneas.
   - «Escribir una reseña» [data-db-of-escribir]: abre la sección de Judge.me de [data-db-mostrar] solo con su botón y su
     formulario (clase db-of-solo-form) y la lleva a la vista; cuando el script de Judge.me ha arrancado, pulsa su botón
     de escribir (widget clásico o nuevo) y pasa al formulario. «Ver las N reseñas» [data-db-of-todas] la abre entera.
     Si este archivo no carga, assets/dalia-ui.js abre la sección igualmente (data-db-mostrar). */
(() => {
  if (window.DaliaOpiniones) return;

  const escritorio = window.matchMedia('(min-width: 750px)');
  // 'instant' y no 'auto': con 'auto' manda el scroll-behavior: smooth que base.css pone en html y en .page-wrapper
  const movimiento = () => (window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth');
  const instancias = new Map();
  const turnos = new WeakMap();
  const dato = (el, clave) => Number(el.dataset[clave]) || 0;
  const visible = (el) => !!el && el.getClientRects().length > 0 && getComputedStyle(el).visibility !== 'hidden';

  function ir(el) {
    try {
      el.scrollIntoView({ behavior: movimiento(), block: 'start' });
    } catch (error) {
      el.scrollIntoView(true);
    }
  }

  // Mira cond() cada `pausa` ms, como mucho `veces` veces; se resuelve con true en cuanto se cumple
  function esperar(cond, veces, pausa) {
    return new Promise((resolver) => {
      let vistas = 0;
      const mirar = () => {
        if (cond()) resolver(true);
        else if (++vistas >= veces) resolver(false);
        else setTimeout(mirar, pausa);
      };
      mirar();
    });
  }

  function textoCuenta(vistas, total, filtro) {
    if (!total) return 'No hay opiniones para mostrar con este filtro.';
    let cola = '';
    if (filtro === 'fotos') cola = ' con fotos';
    else if (filtro !== 'todas') cola = ` de ${filtro} ${filtro === '1' ? 'estrella' : 'estrellas'}`;
    const palabra = total === 1 ? 'opinión' : 'opiniones';
    return vistas < total ? `Mostrando ${vistas} de ${total} ${palabra}${cola}` : `${total} ${palabra}${cola}`;
  }

  function seccionJudgeme(boton) {
    try {
      return document.querySelector(boton.dataset.dbMostrar || '');
    } catch (error) {
      return null;
    }
  }

  // Judge.me: widget clásico (.jdgm-rev-widg, formulario en la página) o nuevo (.jm-review-widget, formulario en ventana)
  const SEL_WIDGET = '.jdgm-rev-widg, .jm-review-widget';
  const SEL_ESCRIBIR = '.jdgm-write-rev-link, [data-testid="write-review-button"]';
  const ventanaAbierta = () => Array.from(document.querySelectorAll('[aria-modal="true"], dialog[open]')).find(visible);

  /* Abre la sección de Judge.me (siempre abre: dalia-ui.js la alternaría) y la lleva a la vista al momento.
     Con formulario, solo su botón y su formulario. Hasta que arranca su script, Judge.me no enseña su widget y su botón
     no hace nada: se espera a que se vea para pulsarlo. Cada pulsación anula la espera de la anterior, así dos clics
     seguidos no abren y cierran el formulario. */
  async function abrirJudgeme(boton, formulario) {
    const seccion = seccionJudgeme(boton);
    if (!seccion) return;
    const turno = (turnos.get(seccion) || 0) + 1;
    turnos.set(seccion, turno);
    const vigente = () => turnos.get(seccion) === turno;
    seccion.classList.add('db-abierto');
    seccion.classList.toggle('db-of-solo-form', formulario);
    ir(seccion);
    if (!formulario) return;

    const enlace = () => {
      const widget = Array.from(seccion.querySelectorAll(SEL_WIDGET)).find(visible);
      return widget ? widget.querySelector(SEL_ESCRIBIR) : null;
    };
    const form = () => seccion.querySelector('.jdgm-form-wrapper');
    const listo = await esperar(() => !vigente() || !!enlace(), 40, 150);
    if (!listo || !vigente()) return;
    const botonJm = enlace();
    if (botonJm && !visible(form())) {
      // Que el href="#" del enlace clásico no lleve arriba del todo
      if (botonJm.tagName === 'A') botonJm.addEventListener('click', (e) => e.preventDefault(), { once: true });
      botonJm.click();
    }
    const abierto = await esperar(() => !vigente() || visible(form()) || !!ventanaAbierta(), 10, 150);
    // El formulario nuevo va en una ventana que ya se lleva el foco: no se mueve la página de detrás
    if (!vigente() || ventanaAbierta()) return;
    const f = form();
    if (abierto && visible(f)) {
      ir(f);
      const campo = f.querySelector(
        'a[href], button, input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])'
      );
      if (campo) campo.focus({ preventScroll: true });
    } else if (visible(enlace())) {
      ir(enlace());
    }
  }

  function iniciar(raiz) {
    if (instancias.has(raiz)) return;
    const control = new AbortController();
    instancias.set(raiz, control);
    const senal = { signal: control.signal };

    // Sin la sección de Judge.me en la página, los botones que la abren no tendrían nada que abrir
    raiz.querySelectorAll('[data-db-of-escribir], [data-db-of-todas]').forEach((boton) => {
      if (seccionJudgeme(boton)) return;
      const caja = boton.closest('[data-db-of-cta]');
      if (caja) caja.hidden = true;
    });
    // La invitación a escribir la primera reseña no pinta nada sin su botón
    if (raiz.hasAttribute('data-db-of-vacia') && !raiz.querySelector('[data-db-of-cta]:not([hidden])')) raiz.hidden = true;

    const lista = raiz.querySelector('[data-db-of-lista]');
    const tarjetas = lista ? Array.from(lista.children) : [];
    const porPagina = Math.max(1, parseInt(raiz.dataset.porPagina, 10) || 6);
    const selOrden = raiz.querySelector('[data-db-of-orden]');
    const carrusel = lista ? lista.closest('[data-db-car]') : null;
    const herramientas = raiz.querySelector('[data-db-of-herr]');
    const vivo = raiz.querySelector('[data-db-of-vivo]');
    const vacio = raiz.querySelector('[data-db-of-vacio]');
    const cajaMas = raiz.querySelector('[data-db-of-mas-caja]');
    const progresoTexto = raiz.querySelector('[data-db-of-progreso-t]');
    const progresoBarra = raiz.querySelector('[data-db-of-progreso-b]');
    const estado = { filtro: 'todas', orden: selOrden ? selOrden.value : 'destacadas', limite: porPagina };

    const coincide = (li) => {
      if (estado.filtro === 'todas') return true;
      if (estado.filtro === 'fotos') return dato(li, 'fotos') > 0;
      return dato(li, 'rating') === Number(estado.filtro);
    };

    // Empates: siempre el orden original (fotos primero, como viene la lista)
    const comparar = (a, b) => {
      const original = dato(a, 'orden') - dato(b, 'orden');
      if (estado.orden === 'recientes') return dato(b, 'fecha') - dato(a, 'fecha') || original;
      if (estado.orden === 'mejor') return dato(b, 'rating') - dato(a, 'rating') || original;
      if (estado.orden === 'peor') return dato(a, 'rating') - dato(b, 'rating') || original;
      return original;
    };

    // Primero se lee todo y después se escribe: así el navegador maqueta una sola vez y no una por tarjeta
    function medir(lis) {
      const filas = [];
      for (const li of lis) {
        const texto = li.querySelector('[data-db-of-texto]');
        const boton = li.querySelector('[data-db-of-leer]');
        if (!texto || !boton || li.classList.contains('db-oc--abierta')) continue;
        filas.push([boton, texto.scrollHeight - texto.clientHeight > 2]);
      }
      for (const [boton, desborda] of filas) boton.hidden = !desborda;
    }

    function anunciar(texto, callado) {
      if (!vivo || vivo.textContent === texto) return;
      if (callado) vivo.setAttribute('aria-live', 'off');
      vivo.textContent = texto;
      if (callado) setTimeout(() => vivo.setAttribute('aria-live', 'polite'), 1000);
    }

    function pintar({ alPrincipio = false, callado = false } = {}) {
      const filtradas = tarjetas.filter(coincide).sort(comparar);
      const total = filtradas.length;
      const grande = escritorio.matches;
      const vistas = grande ? filtradas.slice(0, estado.limite) : filtradas;

      vistas.forEach((li, i) => {
        if (lista.children[i] !== li) lista.insertBefore(li, lista.children[i] || null);
      });
      while (lista.children.length > vistas.length) lista.lastElementChild.remove();
      lista.dataset.dbOfListo = '1';

      if (vacio) vacio.hidden = total > 0;
      if (carrusel) carrusel.hidden = total === 0;
      if (cajaMas) cajaMas.hidden = !grande || vistas.length >= total;
      if (progresoTexto) progresoTexto.textContent = `Has visto ${vistas.length} de ${total}`;
      if (progresoBarra) {
        const parte = total ? Math.round((vistas.length / total) * 1000) / 10 : 0;
        progresoBarra.style.setProperty('--db-of-p', `${parte}%`);
      }

      raiz.querySelectorAll('[data-db-of-filtro][aria-pressed]').forEach((b) => {
        b.setAttribute('aria-pressed', String(b.dataset.dbOfFiltro === estado.filtro));
      });

      anunciar(textoCuenta(vistas.length, total, estado.filtro), callado);
      medir(vistas);

      // El carrusel de dalia-ui.js recalcula flechas y contador «1 / N» con su evento scroll
      if (alPrincipio && lista.scrollLeft !== 0) lista.scrollLeft = 0;
      lista.dispatchEvent(new Event('scroll'));
    }

    function irALista() {
      const destino = herramientas || carrusel;
      if (!destino) return;
      const arriba = destino.getBoundingClientRect().top;
      if (arriba < 0 || arriba > window.innerHeight * 0.75) ir(destino);
    }

    function mostrarMas() {
      const antes = lista.children.length;
      estado.limite += porPagina;
      pintar();
      const primera = lista.children[antes];
      if (primera) {
        primera.setAttribute('tabindex', '-1');
        primera.focus({ preventScroll: true });
      }
    }

    function alternarTexto(boton) {
      const li = boton.closest('li');
      if (!li) return;
      const abierta = li.classList.toggle('db-oc--abierta');
      boton.setAttribute('aria-expanded', String(abierta));
      boton.textContent = abierta ? 'Leer menos' : 'Leer más';
    }

    raiz.addEventListener(
      'click',
      (e) => {
        const objetivo = e.target instanceof Element ? e.target : null;
        if (!objetivo) return;

        const abre = objetivo.closest('[data-db-of-escribir], [data-db-of-todas]');
        if (abre) {
          e.preventDefault();
          e.stopPropagation(); // que dalia-ui.js no la cierre si ya estaba abierta
          abrirJudgeme(abre, abre.hasAttribute('data-db-of-escribir'));
          return;
        }
        if (!lista) return;

        const filtro = objetivo.closest('[data-db-of-filtro]');
        if (filtro) {
          if (filtro.disabled) return;
          let valor = filtro.dataset.dbOfFiltro;
          if (valor !== 'todas' && valor === estado.filtro) valor = 'todas';
          const desdeVacio = !!filtro.closest('[data-db-of-vacio]');
          estado.filtro = valor;
          estado.limite = porPagina;
          pintar({ alPrincipio: true });
          if (filtro.closest('[data-db-of-hist]')) irALista();
          if (desdeVacio) {
            const todas = raiz.querySelector('[data-db-of-filtro="todas"][aria-pressed]');
            if (todas) todas.focus();
          }
          return;
        }

        if (objetivo.closest('[data-db-of-mas]')) {
          mostrarMas();
          return;
        }

        const leer = objetivo.closest('[data-db-of-leer]');
        if (leer) alternarTexto(leer);
      },
      senal
    );

    if (!lista) return;

    if (selOrden) {
      selOrden.addEventListener(
        'change',
        () => {
          estado.orden = selOrden.value;
          pintar({ alPrincipio: true });
        },
        senal
      );
    }
    escritorio.addEventListener('change', () => pintar({ alPrincipio: true, callado: true }), senal);

    // Solo cambia el número de líneas si cambia el ancho (en móvil el alto cambia al esconderse la barra del navegador)
    let ancho = window.innerWidth;
    let marco = 0;
    window.addEventListener(
      'resize',
      () => {
        if (window.innerWidth === ancho) return;
        ancho = window.innerWidth;
        cancelAnimationFrame(marco);
        marco = requestAnimationFrame(() => medir(Array.from(lista.children)));
      },
      { passive: true, signal: control.signal }
    );
    control.signal.addEventListener('abort', () => cancelAnimationFrame(marco), { once: true });
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(() => {
        if (!control.signal.aborted) medir(Array.from(lista.children));
      });
    }

    pintar({ callado: true });
  }

  function destruir(raiz) {
    const control = instancias.get(raiz);
    if (!control) return;
    control.abort();
    instancias.delete(raiz);
  }

  function iniciarEn(contenedor) {
    for (const raiz of Array.from(instancias.keys())) {
      if (!raiz.isConnected) destruir(raiz);
    }
    (contenedor || document).querySelectorAll('[data-db-of]').forEach(iniciar);
  }

  window.DaliaOpiniones = { iniciar: iniciarEn };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => iniciarEn(), { once: true });
  else iniciarEn();
  document.addEventListener('shopify:section:load', (e) => iniciarEn(e.target));
  document.addEventListener('shopify:section:unload', (e) => {
    e.target.querySelectorAll('[data-db-of]').forEach(destruir);
  });
})();
